import { PATH_DASHBOARD } from '@app/routes/paths';
import { Strings } from '@app/constants';
import { SvgColor } from '@app/components/svg-color';
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 40, height: 24 }} />
);

const ICONS = {
  leaves: icon('ic_leaves'),
  projects: icon('ic_projects'),
  configurations: icon('ic_configurations'),
  holidays: icon('ic_holidays'),
  employees: icon('ic_employees'),
  dashboard: icon('ic_dashboard'),
  documents: icon('ic_documents'),
  assets: icon('ic_assets'),
  reviews: icon('ic_reviews'),
};

const navConfig = [
  // Dashboard
  {
    title: Strings.sidebar.dashboard,
    path: PATH_DASHBOARD.dashboard,
    icon: ICONS.dashboard,
  },

  // Employees
  {
    title: Strings.sidebar.members,
    path: PATH_DASHBOARD.employees,
    icon: ICONS.employees,
    children: [
      {
        title: Strings.sidebar.candidates,
        path: PATH_DASHBOARD.candidateList,
      },
      {
        title: Strings.sidebar.interviewees,
        path: PATH_DASHBOARD.IntervieweeList,
      },
      {
        title: Strings.sidebar.interns,
        path: PATH_DASHBOARD.internList,
      },
      {
        title: Strings.sidebar.employees,
        path: PATH_DASHBOARD.employeeList,
      },
    ],
  },

  // Projects
  {
    title: Strings.sidebar.projects,
    path: PATH_DASHBOARD.projects,
    icon: ICONS.projects,
    children: [
      {
        title: Strings.sidebar.projects,
        path: PATH_DASHBOARD.subProjects,
      },
    ],
  },
  // Task Management
  {
    title: Strings.sidebar.taskManagement,
    path: PATH_DASHBOARD.taskManagement,
    icon: ICONS.documents,
    children: [
      {
        title: Strings.sidebar.taskList,
        path: PATH_DASHBOARD.tasksList,
      },
      {
        title: Strings.sidebar.taskBoard,
        path: PATH_DASHBOARD.taskBoard,
      },
      {
        title: Strings.sidebar.overdueTasks,
        path: PATH_DASHBOARD.overdueTaskList,
      },
      {
        title: Strings.sidebar.eta,
        path: PATH_DASHBOARD.eta,
      },
    ],
  },
  // Configurations
  {
    title: Strings.sidebar.configurations,
    path: PATH_DASHBOARD.config,
    icon: ICONS.configurations,
    children: [
      {
        title: Strings.sidebar.designations,
        path: PATH_DASHBOARD.designationList,
      },

      {
        title: Strings.common.departments,
        path: PATH_DASHBOARD.departmentList,
      },
      {
        title: Strings.sidebar.roles,
        path: PATH_DASHBOARD.roleList,
      },
    ],
  },

  // Documents
  {
    title: Strings.sidebar.documents,
    path: PATH_DASHBOARD.documents,
    icon: ICONS.documents,
    children: [
      {
        title: Strings.sidebar.offerLetter,
        path: PATH_DASHBOARD.offerLetter,
      },
      {
        title: Strings.sidebar.compensationLetter,
        path: PATH_DASHBOARD.compensationLetter,
      },
    ],
  },
  // leaves

  {
    title: Strings.sidebar.leaves,
    path: PATH_DASHBOARD.leaves,
    icon: ICONS.leaves,
    children: [
      {
        title: Strings.sidebar.leaves,
        path: PATH_DASHBOARD.leaveEmployee,
      },
      {
        title: Strings.sidebar.leaveManagement,
        path: PATH_DASHBOARD.leaveManagement,
      },
    ],
  },

  // LandingPage

  {
    title: Strings.sidebar.landingPage,
    path: PATH_DASHBOARD.landingPage,
    icon: ICONS.documents,
    children: [
      {
        title: Strings.sidebar.clientTestimonial,
        path: PATH_DASHBOARD.testimonial,
      },
      {
        title: Strings.sidebar.portfolio,
        path: PATH_DASHBOARD.portfolio,
      },
    ],
  },

  // Holidays
  {
    title: Strings.sidebar.holidays,
    path: PATH_DASHBOARD.holidaysList,
    icon: ICONS.holidays,
  },

  // Clients
  {
    title: Strings.sidebar.clients,
    path: PATH_DASHBOARD.clients,
    icon: ICONS.employees,
  },
  // Assets
  {
    title: Strings.sidebar.assets,
    path: PATH_DASHBOARD.assets,
    icon: ICONS.assets,
  },
  // Review
  {
    title: Strings.sidebar.reviews,
    path: PATH_DASHBOARD.reviews,
    icon: ICONS.reviews,
  },
  // MyProfile
  {
    title: Strings.sidebar.myProfile,
    path: PATH_DASHBOARD.myProfile,
    hidden: true,
  },
];

export default navConfig;
